/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Size model module.
 * @module model/Size
 * @version 1.0.0
 */
class Size {
    /**
     * Constructs a new <code>Size</code>.
     * @alias module:model/Size
     */
    constructor() { 
        
        Size.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Size</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Size} obj Optional instance to populate.
     * @return {module:model/Size} The populated <code>Size</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Size();

            if (data.hasOwnProperty('size_one')) {
                obj['size_one'] = ApiClient.convertToType(data['size_one'], 'String');
            }
            if (data.hasOwnProperty('size_two')) {
                obj['size_two'] = ApiClient.convertToType(data['size_two'], 'String');
            }
            if (data.hasOwnProperty('size_three')) {
                obj['size_three'] = ApiClient.convertToType(data['size_three'], 'String');
            }
            if (data.hasOwnProperty('size_four')) {
                obj['size_four'] = ApiClient.convertToType(data['size_four'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Tamaño uno
 * @member {String} size_one
 */
Size.prototype['size_one'] = undefined;

/**
 * Tamaño dos
 * @member {String} size_two
 */
Size.prototype['size_two'] = undefined;

/**
 * Tamaño tres
 * @member {String} size_three
 */
Size.prototype['size_three'] = undefined;

/**
 * Tamaño cuatro
 * @member {String} size_four
 */
Size.prototype['size_four'] = undefined;






export default Size;

